var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChargingPile = function SvgChargingPile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC2626",
    d: "M0 20v-3.125h2.172v-15c0-.497.197-.974.546-1.326C3.067.198 3.54 0 4.034 0h9.932c.493 0 .967.198 1.316.55.35.35.546.828.546 1.325v15H18V20zm7.448-3.75 4.966-5.312H9.31l1.51-2.5H8.206l-2.31 4.374H8.69zm5.586-13.437H4.967v3.75h8.069z"
  })));
};
export default SvgChargingPile;